<template>
  <div class="panel-body">
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th class="col-md-1">{{$t('words.options')}}</th>
              <th>Tipo Registro</th>
              <th>Operação</th>
              <th>Usuário</th>
              <th>IP</th>
              <th>Data</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button class="btn btn-default btn-sm dropdown-toggle" v-bind:title="$t('words.operations')"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" @click="getById(item.id)">
                      <i class="fa fa-eye"></i>
                      {{$t('words.details') }}
                    </a>                 
                </div>
              </div>
            </td>
            <td>{{item.auditable_type}}</td>
            <td>{{item.event}}</td>
            <td>{{item.usuario.nome}}</td>
            <td>{{item.ip_address}}</td>
            <td>{{item.created_at}}</td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="details" :oldData="oldData" :newData="newData" :data="auditoria" :headers="detailsHeaders">
    </show-data>
  </div>
</template>

<script>
  import ShowData from './details';
  export default {
    components: {
      ShowData
    },
    data() {
      return {
          filterable: {
          url: '/api/auditoria',
          storeAction: 'setAuditorias',
          storeName: 'auditoria.data',
          model: 'auditoria',
          showLinkDeleted: false
        },
        model: 'auditoria',
        descricao: 'aud_nome',
        auditoria: [],
        details: '',
        oldData: '',
        newData: '',
        detailsHeaders: [
          'Evento',
          'Usuário',
          'Endereço IP',
          'Dispositivo',
          'Data',
        ]
      };
    },
    beforeMount() {
      this.$store.dispatch('getUserSelect');
    },
    computed: {
      auditorias() {
        return this.$store.state.auditoria.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'auditoria') {
          this.prepareComponent();
        }
      },
    },
    methods: {
      getById(payload) {
        this.filterable.loading = true;
        let auditoria = this.auditorias.find(item => {
          return item.id === payload;
        });
        this.filterable.loading = false;
        this.details = auditoria.auditable_type;
        // this.details = JSON.parse(auditoria.old_values,null, '\t');
        let oldData = JSON.stringify(JSON.parse(auditoria.old_values), null, 2);
        let newData = JSON.stringify(JSON.parse(auditoria.new_values), null, 2);
        oldData = oldData.replace(new RegExp('"', 'g'), '')
          .replace('{', '').replace('}', '').replace('\n', '').replace('[', '').replace(']', '');
        newData = newData.replace(new RegExp('"', 'g'), '')
          .replace('{', '').replace('}', '').replace('\n', '').replace('[', '').replace(']', '');
        this.oldData = oldData;
        this.newData = newData;
        this.auditoria = [];
        this.auditoria.push(auditoria.event);
        this.auditoria.push(auditoria.usuario);
        this.auditoria.push(auditoria.ip_address);
        this.auditoria.push(auditoria.user_agent);
        this.auditoria.push(auditoria.created_at);
        $('#ModalShowData').modal('toggle');
      }
    }
  };
</script>